module.exports = __webpack_public_path__ + "static/media/img1-1.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/melon/nutricheck_foliar/K/img1-1.png
// module id = 1849
// module chunks = 3